/**
 * Les chemins de l’inscription, exportés ici plutôt qu’ajoutés à
 * `lib/chemins.ts` : ce fichier-là appartient à la fondation, et plusieurs lots
 * y écrivent en ce moment. Une constante de plus dans un fichier partagé, c’est
 * un conflit de fusion pour une valeur qui n’intéresse que ce module.
 */

/** Le formulaire public — la démonstration d’un théâtre. */
export const CHEMIN_INSCRIPTION = '/inscription'

/**
 * ★ EVT-02 — le parcours d’inscription RACCOURCI de l’événement ponctuel.
 *
 * C’est le chemin que la vitrine pose dans `ENTREE_EVENEMENT.appel.chemin`
 * (`features/vitrine/publics.ts`) : les deux fichiers sont l’unique point de
 * rendez-vous entre le lot vitrine et le lot LIB/EVT. S’il change, il change
 * aux deux endroits, et le test de la vitrine le voit.
 */
export const CHEMIN_INSCRIPTION_EVENEMENT = '/inscription/evenement'

/** La page qu’ouvre le lien reçu par courriel — le jeton est en query. */
export const CHEMIN_VERIFICATION = '/inscription/verification'

/** Le suivi de la demande, que la personne peut quitter après confirmation. */
export function CHEMIN_ATTENTE(demandeId: string, rejeu = false): string {
  return `/inscription/attente/${demandeId}${rejeu ? `?${MARQUEUR_REJEU}=1` : ''}`
}

/**
 * Le marqueur qui dit à l’écran d’attente « ce lien avait déjà servi ».
 *
 * Il n’ajoute AUCUNE information au serveur : il transporte ce que la page de
 * vérification a constaté — le serveur lui a rendu `provisionnee` du premier
 * coup, ce qui n’arrive que sur un rejeu (une première confirmation rend
 * toujours `provisionnement`). Sans lui, l’écran d’attente afficherait « Votre
 * théâtre est prêt » à quelqu’un qui vient de rouvrir un vieux courriel, sans
 * jamais lui dire pourquoi il n’a rien vu se monter.
 */
export const MARQUEUR_REJEU = 'rejeu'

/**
 * Durée de l’essai, telle qu’elle est annoncée à l’écran.
 *
 * ⚠️ Doublon assumé de `DUREE_DEMO_JOURS` (backend). Le serveur reste seul juge
 * du terme réel — il l’écrit dans le registre au provisionnement ; cette
 * constante ne sert qu’à écrire une phrase. Si les deux divergent un jour,
 * c’est la phrase qui aura tort, pas l’essai.
 */
export const DUREE_ESSAI_JOURS = 30

/**
 * ★ EVT-03 — délai de conservation après la date de l’événement, tel qu’il est
 * ANNONCÉ à l’écran. Même doublon assumé que `DUREE_ESSAI_JOURS` : c’est le
 * serveur (`DELAI_CONSERVATION_EVENEMENT_JOURS`) qui décide du terme réel, en
 * l’écrivant dans le registre au provisionnement.
 */
export const DELAI_CONSERVATION_EVENEMENT_JOURS = 90
